__webpack_require__.p = "https://dpzzs9c76qolf.cloudfront.net/app/academy/397/";